import { toast } from "sonner";

// Toast each newly-unlocked badge returned in `_meta.new_badges`
export function celebrateBadges(meta) {
  const newOnes = meta?.new_badges || [];
  newOnes.forEach((b, i) => {
    setTimeout(() => {
      toast.success(`🏆 Badge unlocked: ${b.name}`, {
        description: b.desc,
        duration: 5000,
      });
    }, i * 600);
  });
}
